<template>
  <div class="warpper">
    <div class="container">
      <crumb />
      <div class="lg">
        <div class="cart">
          <div class="cart-head">
            <div class="selectAll" @click="setSelectAll()">
              <div class="cart-checkbox top" :class="isAs ? 'on' : ''"></div>
              全选
            </div>
            <div class="productName th1">商品信息</div>
            <div class="unitPrice th2">单价</div>
            <div class="amounttitle th3">数量</div>
            <div class="money th4">金额</div>
            <div class="oper">操作</div>
          </div>
          <div class="cart-item" v-for="(item, index) in cartList" :key="index" :class="item.isSelected ? 'on' : ''">
            <div class="selectAll td" @click="setChecked(index)">
              <div
                class="cart-checkbox"
                :class="item.isSelected ? 'on' : ''"
              ></div>
            </div>
            <div class="cart_td">
              <img class="photo" :src="item.productImg" alt="" />
              <div class="productName">
                <div class="pro_h1">
                  {{ item.productName }}
                </div>
                <div class="pro_can">
                  <div>{{ item.skuName }}</div>
                </div>
              </div>
            </div>
            <div class="unitPrice td1">{{ item.productPrice }}</div>
            <div class="amount td2">
              <div class="less" @click="lessAmount(index)"></div>
              <input type="text" class="num" :value="item.productNum" />
              <div class="plus" @click="plusAmount(index)"></div>
            </div>
            <div class="money mb td3">
              {{ (item.productNum * (item.productPrice * 100)) / 100.0 }}
            </div>
            <div class="oper td4">
              <img
                @click="updateCartNum(item.id, 0)"
                class="delete"
                src="../assets/images/cart_delete.png"
                alt=""
              />
            </div>
          </div>
          <!-- <div class="nolist">空空如也~</div> -->
          <div class="cart-bottom">
            <div class="left center">
              <!-- <div class="cart-checkbox on"></div>
              <div class="left_btn">全选</div>
              <div class="left_btn">删除</div> -->
            </div>
            <div class="right">
              <div class="total">
                <div class="total_con">
                  <span class="kj">合计：</span
                  ><span class="money">{{ totalPrice  }}</span>
                </div>
                <div class="total_sel">已选商品{{ totalNum }}件</div>
              </div>
              <!-- <div class="btn off">立即购买</div> -->
              <div class="btn" @click="confirmHandle()">立即购买</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { postNoLoading } from '../utils/posts'
import { useStore } from 'vuex'

import crumb from '../components/bread-crumb/Index.vue'
import { ElMessageBox } from 'element-plus'
export default {
  name: '购物车',
  components: {
    crumb
  },
  setup () {
    const store = useStore()
    const router = useRouter()
    const userInfo = store.state.userInfo
    const cartList = ref([])
    const totalNum = ref(0) // 总数量
    const totalPrice = ref(0) // 总价格
    const isAs = ref(false) // 全选

    const confirmHandle = () => {
      router.push({ path: '/product/placeOrder' })
    }
    // 设置选中
    const setChecked = (idx) => {
      cartList.value[idx].isSelected = !cartList.value[idx].isSelected
      const checkedstr = cartList.value.map((m) => m.isSelected).join(',')
      let isAllAs = false
      if (checkedstr.indexOf('false') === -1) {
        isAllAs = !(cartList.value.length <= 0)
      }
      caleTotal()
      isAs.value = isAllAs
      postNoLoading(`cart/select/${userInfo.uid}`, {
        id: cartList.value[idx].id,
        isChecked: cartList.value[idx].isSelected ? 1 : 0
      })
    }
    // 设置全选或全不选
    const setSelectAll = () => {
      let isChecked = 0

      if (isAs.value) {
        // 取消全选
        isAs.value = false
        for (let i = 0; i < cartList.value.length; i++) {
          cartList.value[i].isSelected = isAs.value
        }
      } else {
        // 全部选中
        isAs.value = true
        for (let i = 0; i < cartList.value.length; i++) {
          cartList.value[i].isSelected = isAs.value
        }
        isChecked = 1
      }
      caleTotal()
      postNoLoading(`cart/selectall/${userInfo.uid}`, {
        isChecked
      })
    }
    // 获取购物车列表
    const getcartHandle = () => {
      postNoLoading(`cart/getcart/${userInfo.uid}`).then((res) => {
        cartList.value = res.data
        if (res.data.length > 0) {
          const checkedstr = res.data.map((m) => m.isSelected).join(',')
          if (checkedstr.indexOf('false') === -1) {
            isAs.value = true
          }
        }

        caleTotal()
      })
    }
    // 购物车数量加
    const plusAmount = (idx) => {
      cartList.value[idx].productNum += 1
      caleTotal()
      postNoLoading(`cart/cartnum/${userInfo.uid}`, {
        id: cartList.value[idx].id,
        num: cartList.value[idx].productNum
      }).then((res) => {})
    }
    // 购物车数量减
    const lessAmount = (idx) => {
      cartList.value[idx].productNum -= 1
      caleTotal()
      const num = cartList.value[idx].productNum
      if (num === 0) {
        updateCartNum(cartList.value[idx].id, 0)
      } else {
        updateCartNum(cartList.value[idx].id, cartList.value[idx].productNum)
      }
    }
    // 修改商品数量
    const updateCartNum = (id, num) => {
      if (num === 0) {
        ElMessageBox.confirm('确定删除该商品？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            postNoLoading(`cart/cartnum/${userInfo.uid}`, {
              id: id,
              num: num
            }).then((res) => {
              getcartHandle()
            })
          })
          .catch(() => {
            getcartHandle()
          })
      } else {
        postNoLoading(`cart/cartnum/${userInfo.uid}`, {
          id: id,
          num: num
        }).then((res) => {
          getcartHandle()
        })
      }
    }
    // 统计金额
    const caleTotal = () => {
      if (cartList.value.length <= 0) {
        isAs.value = false
      }

      const selectList = cartList.value.filter((m) => m.isSelected === true)
      totalNum.value =
        selectList.length === 0
          ? 0
          // eslint-disable-next-line no-eval
          : eval(selectList.map((m) => m.productNum).join('+'))
      // eslint-disable-next-line no-eval
      totalPrice.value =
        selectList.length === 0
          ? 0
          // eslint-disable-next-line no-eval
          : eval(
            selectList.map((m) => m.productNum * (m.productPrice * 100)).join('+')
          ) / 100.0
    }
    onMounted(() => {
      getcartHandle()
    })
    return {
      updateCartNum,
      confirmHandle,
      totalPrice,
      totalNum,
      isAs,
      setSelectAll,
      setChecked,
      plusAmount,
      cartList,
      lessAmount,
      getcartHandle
    }
  }
}
</script>
<style lang="scss" scoped>
.pro_h1 {
  line-height: 22px;
}
.pro_can {
  margin: 12px 0 0 0;
  display: flex;
  div {
    padding: 0 20px 0 0;
    color: #999999;
  }
}
.container {
  width: 1200px;
}
.lg {
  display: flex;
  margin: 36px 0 130px 0;
}
.nolist {
  margin: auto;
  text-align: center;
  color: #999;
}
.cart {
  width: 100%;
  .cart_td {
    flex: 4;
    display: flex;
    .productName {
      color: #3e3a39;
    }
  }
}
.cart-head .productName.th1 {
  flex: 5.6;
}
.cart-head .unitPrice.th2 {
  flex: 2;
}
.cart-head .amounttitle.th3 {
  flex: 2;
}
.cart-head .money.th4 {
  flex: 2;
}
.cart-head,
.cart-tips {
  display: flex;
  background: #eeeeee;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  height: 48px;
  color: #959595;
  text-align: center;
}
.cart-tips .tips {
  display: flex;
  align-items: center;
}
.cart-tips .tips .icon {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}
.cart-head {
  background-color: #eeeef0;
  height: 48px;
  margin: 0 0 24px 0;
}
.selectAll {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 70px;
}
.selectAll.td {
  width: 40px;
}

.cart-item {
  display: flex;
  background-color: #f8f6f6;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border: 1px solid #e8e8e8;
  margin: 0 0 24px 0;
  &:hover {
    background: #fff4e8;
    border: 1px solid #fff4e8;
  }
  &.on {
    background: #fff4e8;
    border: 1px solid #fff4e8;
  }
}
.phototitle {
  width: 100px;
}
.photo {
  width: 80px;
  height: 80px;
}
.productName {
  padding: 0 20px;
}
.unitPrice,
.money,
.oper {
  text-align: center;
}
.unitPrice.td1 {
  flex: 1.3;
  padding: 0 20px;
  color: #3e3a39;
  &::before {
    content: "¥";
  }
}
.td3 {
  flex: 1.3;
}
.mb {
  color: #fc4353;
  font-size: 16px;
  font-weight: bold;
}
.mb::before {
  content: "¥";
  font-size: 12px;
}
.oper .delete {
  width: 14px;
  height: 14px;
  cursor: pointer;
}
.amounttitle {
  width: 180px;
}
.amount {
  flex: 1.2;
  display: flex;
  justify-content: center;
  width: 180px;
}
.amount .less,
.amount .plus {
  position: relative;
  width: 24px;
  height: 24px;
  border: 1px solid #999999;
  border-radius: 0 4px 4px 0;
  cursor: pointer;
}
.amount .plus {
  border-radius: 0 4px 4px 0;
  background: white;
}
.amount .less {
  border-radius: 4px 0 0 4px;
  background: white;
}

.amount .less::before,
.amount .plus::before,
.amount .plus::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 10px;
  height: 2px;
  background-color: #999999;
}
.amount .plus::after {
  width: 2px;
  height: 10px;
}
.amount .num {
  width: 80px;
  height: 24px;
  text-align: center;
  font-size: 14px;
  color: #333;
  border: solid #999999;
  border-width: 1px 0;
}

.cart-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100px;
}
.cart-bottom .left,
.cart-bottom .right {
  display: flex;
  justify-content: space-evenly;
}
.cart-bottom .left.center {
  padding: 0 0 0 22px;
  align-items: center;
}
.left_btn {
  margin: 0 0 0 12px;
}
.cart-bottom .btn {
  width: 160px;
  height: 50px;
  border-radius: 4px;
  background-color: #ff5e41;
  color: #fff;
  font-weight: bold;
  text-align: center;
  line-height: 50px;
  cursor: pointer;
}
.cart-bottom .off {
  background-color: #ccc;
}
.cart-bottom .total {
  display: flex;
  flex-direction: column;
  padding: 0 20px;
  justify-content: center;
}
.cart-bottom .total .money {
  font-size: 20px;
  color: #fc4353;
  font-weight: bold;
}
.cart-bottom .total_con {
  display: flex;
  align-items: center;
  margin: 0 0 7px 0;
}
.cart-bottom .total_sel {
  font-size: 14px;
  color: #3e3a39;
  text-align: right;
}
.cart-bottom .total_con .kj {
  font-size: 14px;
}
.cart-bottom .total .money::before {
  content: "¥";
}
.cart-checkbox {
  position: relative;
  width: 20px;
  height: 20px;
  border-radius: 100%;
  box-sizing: border-box;
  background-color: #f8f6f6;
  border: 1px solid #959595;
  cursor: pointer;
  &.top{
    background: #EEEEEE
  }
}

.cart-checkbox.on {
  border: 0;
  background-color: #ff5e41;
}

.cart-checkbox.on::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 4px;
  margin: auto;
  width: 5px;
  height: 10px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
</style>
